<template>
    <div class="w-full flex flex-col lg:flex-row justify-between">
        <Table 
            :title="`Fraud Protection Restrictions`" 
            :class="`mx-auto w-full flex-grow max-w-screen-md`"
            :showSubmit="false"
            :useRecords="false"
            :showCancel="false"
            @quickFilter="(e) => { quickFilter = e; }">
            <div v-if="locked.length == 0" class="text-sm italic text-center">
                No active restrictions.
            </div>
            <div v-for="l in locked" :key="l.id" 
                :class="`${focusedLock == l.id ? 'mn3-cancel' : ''} 
                    ${quickFilter != '' && !lockContains(l, quickFilter) ? 'hidden' : ''} w-full flex flex-col justify-between items-center p-2 border-b`">
                <div v-if="focusedLock == l.id" class="w-full text-center text-base underline">Are you sure you want to clear this lock?</div>
                    <div class="w-full flex flex-row justify-between items-center">
                    <div class="flex flex-col flex-grow">
                        <div class="flex flex-row items-center">
                            <Icon id="user" class="h-4 w-4 mr-1" />
                            <div class="font-bold mr-2">{{l.attributes.username}},</div>
                            <div>Accounts: {{l.attributes.accounts}}</div>
                        </div>
                        <div class="flex flex-row font-mono items-center">
                            <Icon id="lock" class="h-4 w-4 mr-1" />
                            {{l.attributes.restriction}} - {{l.attributes.reason}}
                        </div>
                        <div class="text-sm font-mono ml-5">Expires in {{l.attributes.ttl}}s</div>
                    </div>
                    <div class="font-bold flex flex-row items-center uppercase bg-red-500">
                        <div v-if="focusedLock != l.id" class="flex justify-end">
                            <Button @click="focusedLock = l.id" label="Clear Lock" icon="lock-open-solid" />
                        </div>
                        <div v-else  class="flex justify-end">
                            <Button @click="unlock(l)" label="Clear" />
                            <Button @click="focusedLock = ''" label="Cancel" />
                        </div>
                    </div>
                </div>
            </div>
        </Table>
	</div>
</template>

<script>
	import Button from "@/components/Button.vue";
	import Form from "@/components/Form.vue";
	import Field from "@/components/Field.vue";
	import Icon from "@/components/Icon.vue";
	import Table from "@/components/Table.vue";
    import { ref } from 'vue'

	export default {
		components:{
            Button,
			Form,
			Field,
            Icon,
            Table
		},
		data(){
			return {
			};
		},
        methods: {
            async loadLockedMembers(){
                let fetched = await this.$fapi.get("security/restrictions");
                this.locked = fetched.data.data;
            },
            lockContains(lock, needle){
                needle = (needle + '').toLowerCase();
                let usernameFound = (lock.attributes.username + '').toLowerCase().indexOf(needle) != -1
                let accountsFound = (lock.attributes.accounts + '').toLowerCase().indexOf(needle) != -1
                let reasonFound = (lock.attributes.reason + '').toLowerCase().indexOf(needle) != -1
                let restrictionFound = (lock.attributes.restriction + '').toLowerCase().indexOf(needle) != -1

                if(usernameFound || accountsFound || reasonFound || restrictionFound)
                    return true;

                return false;
            },
            typeToIcon(type){
                switch(type){
                    case'username':
                        return 'user-solid';

                    case 'ip':
                        return 'pc';
                }

                return 'lock';
            },  
            async unlock(lock){             
                await this.$fapi.delete(lock.links.self);
                this.focusedLock = '';
                this.loadLockedMembers();
            }
        },  
		created(){
            document.title = 'Unlock Accounts'
            this.loadLockedMembers();
		}, 

        setup(){
            
            const locked = ref([]);

			/* Form field values */
			let fv = {}
            const quickFilter = ref('')
            const focusedLock = ref('')

            return { 
                quickFilter,
                focusedLock,
				fv,
                locked
            }

        }
	}
	
</script>
